import { render, staticRenderFns } from "./ConcludingList.vue?vue&type=template&id=5612c59e&scoped=true"
import script from "./ConcludingList.vue?vue&type=script&lang=js"
export * from "./ConcludingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5612c59e",
  null
  
)

export default component.exports